<section class="ib-switch-sell-car-card">
    <header class="ib-switch-sell-car-card__header">
        <img [src]="currentImg" (error)="onImageError()" class="ib-switch-sell-car-card__logo" />
    </header>

    <section class="ib-switch-sell-car-card__main" [ngClass]="{ '--hotel-dispo': hasHotelDispo }">
        <section class="ib-switch-sell-car-card__info" [ngClass]="{ '--no-hotel-dispo': !hasHotelDispo }">
            <div class="ib-switch-sell-car-card__info_header">
                <h1 class="ib-switch-sell-car-card__info__header__title">
                    {{ switchSellCarData.name }}
                </h1>
                <div *ngIf="hasHotelDispo" class="ib-switch-sell-car-card__info__header__icons">
                    <span class="ib-switch-sell-car-card____info__headericons__icon">
                        <img src="/iberia-web-content/imagenes/switch-sell/budget.svg"
                            class="ib-switch-sell-car-card__icons__icon__logo" />
                    </span>
                    <span class="ib-switch-sell-car-card__info__header__icons__icon">
                        <img src="/iberia-web-content/imagenes/switch-sell/avis.svg"
                            class="ib-switch-sell-car-card__info__header__icons__icon__logo" />
                    </span>
                </div>
            </div>

            <div class="ib-switch-sell-car-card__info__feature">
                <img src="/iberia-web-content/imagenes/switch-sell/check.png"
                    class="ib-switch-sell-car-card__info__feature__icon" alt="" />
                <p class="ib-switch-sell-car-card__info__feature__text">
                    {{'ALP_SWITCH_SELL_CAR_CONDITION_TXT_1'|translate}}
                </p>
            </div>

        </section>

        <section class="ib-switch-sell-car-card__price" [ngClass]="{ '--no-hotel-dispo': !hasHotelDispo }">

            <h4 class="ib-switch-sell-car-card__price__title">
                {{'ALP_SWITCH_SELL_CAR_SUBTXT'|translate}}
                <span class="ib-switch-sell-car-card__price__title__discount">
                    {{savingPrice}}
                </span>
            </h4>
            <h1 class="ib-switch-sell-car-card__price__value">{{switchSellCarData.amount | customCurrency:
                switchSellCarData.currency}} </h1>

            <p class="ib-switch-sell-car-card__price__info">
                {{'ALP_SWITCH_SELL_PRICE_TXT_2'|translate}}
            </p>

        </section>

        <button (click)="redirectToIbh()" class="ib-switch-sell-car-card__button">
            {{'ALP_SWITCH_SELL_CAR_BTN'|translate}}
        </button>

        <div *ngIf="!hasHotelDispo" class="ib-switch-sell-car-card__icons">
            <span class="ib-switch-sell-car-card__icons__icon">
                <img src="/iberia-web-content/imagenes/switch-sell/budget.svg" />
            </span>
            <span class="ib-switch-sell-car-card__icons__icon">
                <img src="/iberia-web-content/imagenes/switch-sell/avis.svg" />
            </span>
        </div>
    </section>
</section>